import { render, staticRenderFns } from "./Formulations.vue?vue&type=template&id=24d793e1&"
import script from "./Formulations.vue?vue&type=script&lang=js&"
export * from "./Formulations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports